import { BaseTranslations } from '../../../../baseTranslations';
import { useCmsClientContext } from '../../../../utils/cmsPageContext/useCmsClientContext';
import { getClientTranslations } from '../../../../utils/translations/getClientTranslations';
import { enquiryPurposeOptions, monthOptions } from '../../constants';
import { useSafeCarInsuranceContext } from '../../context/useSafeCarInsurance';
import { FormInput } from '../../Form/FormInput';
import { FormSelect } from '../../Form/FormSelect';
import { Checkbox } from '../../Inputs/Checkbox';
import { StepHeader } from '../StepHeader';

export const ContactDetailsSingsaver: React.FC = () => {
  const context = useCmsClientContext();
  const staticText = getClientTranslations(BaseTranslations, context);
  const carInsuranceContext = useSafeCarInsuranceContext();
  if (!carInsuranceContext) {
    return null;
  }
  const {
    requestParams: {
      user: { setValue: setValueUser, value: ValueUser },
      vehicle: { value: valueVehicle, setValue: setValueVehicle },
    },
  } = carInsuranceContext;

  const { firstName, lastName } = ValueUser;
  const { enquiryPurpose, insuranceExpiryDate, noInsurance } = valueVehicle;

  const updateContact = (updatedValue: Partial<typeof ValueUser>) => {
    const contact = {
      ...ValueUser,
      ...updatedValue,
    };

    setValueUser(contact);
  };

  const updateVehicle = (updatedValue: Partial<typeof valueVehicle>) => {
    const vehicle = {
      ...valueVehicle,
      ...updatedValue,
    };

    setValueVehicle(vehicle);
  };

  return (
    <div className="mt-4 flex w-full flex-col gap-4">
      <StepHeader
        title={staticText.vehicle_details}
        subTitle={staticText.vehicle_details_subtitle}
        stepNumber={3}
      />
      <FormSelect
        options={enquiryPurposeOptions}
        value={enquiryPurpose ?? 'How to Apply'}
        onChange={(val: string) => updateVehicle({ enquiryPurpose: val })}
        label={staticText.enquiry_purpose}
        placeholder={staticText.select_enquiry_purpose}
      />
      <div className="flex items-center gap-2">
        <Checkbox
          onClick={() => updateVehicle({ noInsurance: !noInsurance })}
          defaultValue={noInsurance}
          containerClass="!size-5"
        />
        <span className="font-medium text-gray-900 text-sm">
          {staticText.i_dont_have_insurance}
        </span>
      </div>
      {!noInsurance && (
        <FormSelect
          options={monthOptions}
          value={insuranceExpiryDate ?? new Date().getMonth().toString()}
          onChange={(val: string) =>
            updateVehicle({ insuranceExpiryDate: val })
          }
          label={staticText.car_insurance_expiry}
          placeholder={staticText.select_month}
        />
      )}
      <FormInput
        label={staticText.first_name}
        value={firstName}
        placeholder={staticText.first_name}
        type="text"
        onChange={(value) => updateContact({ firstName: value })}
      />
      <FormInput
        label={staticText.last_name}
        value={lastName}
        placeholder={staticText.last_name}
        type="text"
        onChange={(value) => updateContact({ lastName: value })}
      />
    </div>
  );
};
